/***
 *
 *   MOBILE BOTTOM BAR
 *   Ported from ui-reference/src/components/layouts/mobile-bottom-bar.tsx.
 *
 *   Replaces the old `.popup` hamburger drawer in nav/app/app.scss: below md
 *   the sidebar is hidden outright and this is the whole of the app navigation,
 *   which is why it takes the same `items` array.
 *
 *   PROPS
 *   items: array of { key, label, icon, link, action, external }
 *
 **********/

import { NavLink } from 'react-router-dom';
import { Icon, cn } from 'components/lib';
import Style from './mobileBar.tailwind.js';

export function MobileBottomBar(props) {
    const content = (item) => (
        <>
            {item.icon && <Icon image={item.icon} size={20} color="currentColor" />}
            {item.label && <span className={Style.label}>{item.label}</span>}
        </>
    );

    const classes = (isActive) => cn(Style.item, isActive ? Style.itemActive : Style.itemIdle);

    return (
        <nav className={Style.bar}>
            {props.items?.map((item) => {
                const key = item.key || item.link || item.label;

                if (item.external || item.link?.includes('http'))
                    return (
                        <a
                            key={key}
                            href={item.link}
                            target="_blank"
                            rel="noreferrer"
                            className={classes(false)}>
                            {content(item)}
                        </a>
                    );

                if (item.link)
                    return (
                        <NavLink key={key} to={item.link} className={({ isActive }) => classes(isActive)}>
                            {content(item)}
                        </NavLink>
                    );

                return (
                    <button key={key} type="button" onClick={item.action} className={classes(false)}>
                        {content(item)}
                    </button>
                );
            })}
        </nav>
    );
}
